<template>
  <LinkWrapper
    :link-url="(content as SubHero).fields.linkUrl"
    :is-external-link="(content as SubHero).fields.isExternalLink"
  >
    <div class="flex flex-col mb-4 shadow-lg md:flex-row md:max-h-[348px]">
      <div
        class="box-border relative flex flex-col justify-around w-full h-auto p-6 rounded-t rounded-b-none md:rounded-l md:rounded-r-none md:w-1/2"
        :class="setCmsTemplateClasses((content as SubHero).fields.template, 'sub-hero')"
      >
        <div>
          <h2
            v-if="(content as SubHero).fields.title"
            class="mb-2 text-2xl font-bold md:text-base lg:text-lg xl:text-2xl 2xl:text-5xl"
            :class="textColor"
          >
            {{ (content as SubHero).fields.title }}
          </h2>
          <p class="mb-5 text-sm md:text-xs xl:text-lg" :class="textColor">{{ (content as SubHero).fields.text }}</p>
        </div>
        <CButton
          v-if="(content as SubHero).fields.buttonText"
          class="self-start px-8 py-0"
          variant="secondary"
          size="small"
        >
          {{ (content as SubHero).fields.buttonText }}
        </CButton>
      </div>
      <div
        class="flex justify-center overflow-hidden bg-white rounded-b md:rounded-bl-none md:rounded-r md:w-1/2 md:border-r md:border-l-none"
      >
        <ContentfulImage
          class="w-full h-[calc((100vw_-_32px)_*_0.4)] md:h-auto"
          :entry="(content as SubHero).fields.image"
          :width="870"
          :height="348"
          fit="fill"
        />
      </div>
    </div>
  </LinkWrapper>
</template>

<script setup lang="ts">
import { setCmsTemplateClasses, getCmsTemplateSpectrum } from '@/config/cms';
import type { ContentfulImageType } from '@/types/contentful';

type SubHero = {
  fields: {
    template: string;
    title: string;
    text: string;
    buttonText: string;
    image: ContentfulImageType;
    isExternalLink: boolean;
    linkUrl: string;
  };
};

type Props = {
  content?: SubHero;
};

const props = withDefaults(defineProps<Props>(), {
  content: undefined,
});

const textColor = computed(() => {
  return getCmsTemplateSpectrum((props.content as SubHero).fields?.template) === 'dark'
    ? 'text-white'
    : 'text-primary-900';
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'SubHero',
});
</script>
